import {  KeyValue } from '@angular/common';
import {  Component, EventEmitter, Input,  OnChanges,  OnDestroy,  OnInit,  Output,  SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl,  FormControl, FormGroup, NgForm, } from '@angular/forms';
import { SharedDataService,SuppliersService } from '../../all-services';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { 
  Civility, 
  Contact, 
  Supplier, 
  SupplierContact,
  SupplierStatut } from '../../all-models';
import {  PafLabelDirective } from '../../Directives/paf-label/paflabel.directive';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'supp-contact-row',
  templateUrl: './supp-contact-row.component.html',
  styleUrls: ['./supp-contact-row.component.scss'],
})
export class SuppContactRowComponent implements OnInit, OnChanges, OnDestroy  {

  private pafLabels: PafLabelDirective = null;
  @ViewChild('supplierContactRowForm') public supplierContactRowForm: NgForm;

  @ViewChild('supplierContactRowForm') public FrmSupplierContactRow: FormGroup;

  @Input() supplierContact?: SupplierContact;
  @Input() noHeader: boolean = false;
  @Input() addButton: boolean = false;
  @Input() delButton: boolean = false;
  @Input() updateButton: boolean = false;
  @Input() supplierStatut?: SupplierStatut = null;
  @Input() disabled?: boolean = false;
  @Input() isEditing?: boolean = false;
  @Input() required?: boolean = false;
  @Input() isEmptyReferent?: boolean = false;

  @Output() updateSupplierContact: EventEmitter<SupplierContact> = new EventEmitter<SupplierContact>();
  @Output() addSupplierContact: EventEmitter<SupplierContact> = new EventEmitter<SupplierContact>();
  @Output() deleteSupplierContact: EventEmitter<SupplierContact> = new EventEmitter<SupplierContact>();
  @Output() ContactRowValidChange: EventEmitter<KeyValue<SupplierContact, boolean>> = new EventEmitter<KeyValue<SupplierContact, boolean>>();
  @Output() setSupplierContactAsReferent: EventEmitter<SupplierContact> = new EventEmitter<SupplierContact>();
  @Input() showErrors: Subject<boolean>;


  private _subscriptions: Subscription[]=[];
  validate({ value }: FormControl) {
    this.updateValidity();
    return this.FrmSupplierContactRow.errors;
  }
  get contact(): Contact {
    return this.supplierContact?.Contact;
  }
  get supplier(): Supplier {
    return this.supplierContact ? this.supplierContact.Supplier : new Supplier();
  }

  get supplierId(): number {
    return this.supplier?.Id || 0;
  }

  get isReferent():boolean{
    return this.supplierContact?.IsReferent ==1;
  }
  constructor(
    public sharedDataSvc: SharedDataService,
    public route: ActivatedRoute,
    private suppliersSvc:SuppliersService) {
      this.pafLabels = new PafLabelDirective(this.sharedDataSvc, this.route, null);
    }


  get civilityCod(): string {
    return this.civility ? this.civility.Cod : null;
  }
  ngOnInit(): void {
    if (this.showErrors) this._subscriptions.push(this.showErrors.subscribe(v => this.updateValidity()));
  }
  ngOnDestroy(): void {
    this._subscriptions.forEach(sub=>sub.unsubscribe());
  }

  updateValidity():void{
      Object.keys(this.FrmSupplierContactRow.controls).forEach((key, i) => {
        let control: AbstractControl = this.FrmSupplierContactRow.controls[key];
        control.markAsTouched();
      });
      this.onFormStatutChange();
  }



  onFormStatutChange():void {
   if (this.FrmSupplierContactRow.status == 'INVALID') {
      let filteredErrors=
      Object.keys(this.FrmSupplierContactRow.controls)
      .filter( ctrlName => {
        let ctrl = this.FrmSupplierContactRow.controls[ctrlName];
        return (ctrl.invalid && !ctrl.hasError('emailUnique'));
      })
      .map((ctrlName:string) => {
          return {
            name:ctrlName, 
            errors:this.FrmSupplierContactRow.controls[ctrlName].errors
          }
        });
      
      this.errors = filteredErrors.length>0 ? filteredErrors : undefined;
      //this.ContactRowValidChange.emit({ key: this.supplierContact, value: false });      
    } else {
      this.errors = undefined;
      //this.ContactRowValidChange.emit({ key: this.supplierContact, value: true });
    }
  }


  get existingContactWarning():Contact | undefined{
    return (<any>(this.supplierContact))?.existingContactWarning;
   }
   set existingContactWarning(value : Contact | undefined){
    if (this.supplierContact){
      (<any>(this.supplierContact)).existingContactWarning = value;
    }
   }

   get errors():any | undefined{
    return (<any>(this.supplierContact))?.errors;
   }
   set errors(value : any | undefined){
    if (this.supplierContact){
      (<any>(this.supplierContact)).errors = value;
    }
   }

  onEmailStatutChange():void {
    let contact : Contact | undefined;
    if (this.FrmSupplierContactRow?.controls['Email']?.hasError('emailUnique')) {
      contact = this.FrmSupplierContactRow?.controls['Email'].getError('emailUnique').contact;
    }
    if (this.existingContactWarning?.Id!= contact?.Id){
      this.existingContactWarning = contact;
    }
    
  }

  public Label(lblCod: string): Observable<string> {
    return this.pafLabels.getLabel(lblCod);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['supplierContact'] && this.supplierContact) {
      if (!this.supplierContact.Contact) {
        this.supplierContact.Contact = new Contact();
        this.supplierContact.Contact.Id = this.supplierContact.ContactId;
      }
      if (!this.supplierContact.Contact.Civility){
        this.supplierContact.Contact.Civility = new Civility();
        this.supplierContact.Contact.Civility.Id= this.supplierContact.Contact.CivId;
      }
      setTimeout((): void => {
        this.FrmSupplierContactRow.statusChanges.subscribe(res => this.onFormStatutChange());
        this._subscriptions.push(this.FrmSupplierContactRow.controls['Email'].statusChanges.subscribe(res=> this.onEmailStatutChange()));
        this.updateValidity();
      }, 0);
    }
    if (changes['addButton']) {
      if (this.addButton) this.editActivated = true;
    }
    if (changes['disabled']) {
      if (this.disabled) this.editActivated = false;
    }
    if (changes['isEditing']) {
      this.editActivated= this.isEditing && !this.disabled;
    }
    if (changes['isEmptyReferent'] && this.isEmptyReferent) {
      this.TopCreateAccount= true;
      this.required = true;
    }
    if (changes['ContactRowValidChange'] && !!this.ContactRowValidChange) {
      setTimeout(()=>this.onFormStatutChange(),0);
    }
  }


  private _editActivated: boolean = false;
  get editActivated(): boolean {
    return this._editActivated;
  }
  set editActivated(value:boolean) {
    this._editActivated = value;
  }

  public get civility(): Civility {
    return this.contact ? this.contact.Civility : null;
  }
  public set civility(value: Civility) {
    if (this.contact) {
      this.contact.Civility = value;
      this.contact.CivId = value ? value.Id : 1;
    }
  }
  

  delete(): void {
    this.deleteSupplierContact.emit(this.supplierContact);
  }

  add(): void {
    if (this.btnAddDisabled) return;
    if (this.contactDejaExistant != null) {
      this.sharedDataSvc.pafConfirm('Msg_Associer_contact_Existant_au_fournisseur', 
      (): void => {
        if (!this.contactDejaExistant.LngCod) this.contactDejaExistant.LngCod = this.supplier?.LngCod;
        this.supplierContact.Contact = this.contactDejaExistant;
        this.supplierContact.ContactId = this.contactDejaExistant.Id;
        this.addSupplierContact.emit(this.supplierContact);
        this.updateValidity();
      },
      null);
    } else {
      if (this.TopCreateAccount) this.supplierContact.CreateAccount = 1;
      if ( this.supplierContact?.Contact && !this.supplierContact?.Contact?.LngCod) this.supplierContact.Contact.LngCod = this.supplier?.LngCod;
      this.addSupplierContact.emit(this.supplierContact);
    }
  }

  update(): void {
    if (!this.sharedDataSvc.CanSave(this.supplierContactRowForm)) return;
    if ( this.supplierContact?.Contact && !this.supplierContact?.Contact?.LngCod) this.supplierContact.Contact.LngCod = this.supplier?.LngCod;
    this.updateSupplierContact.emit(this.supplierContact);
    this.editActivated = false;
  }

  clear(): void {
    if (!this.FrmSupplierContactRow) return;
    Object.keys(this.FrmSupplierContactRow.controls).forEach((key, i) => {
      let control: AbstractControl = this.FrmSupplierContactRow.controls[key];
      control.setValue('');
      control.setErrors(null);
    });
  }

  public contactBackup: Contact = null;
  public civilityBackup: Civility = null;
  edit(): void {
    this.contactBackup = Object.assign({}, this.contact);
    this.civilityBackup = Object.assign({}, this.civility);

    this.editActivated = true;
  }
  undo(): void {
    if (this.supplierContact){
      this.supplierContact.Contact = Object.assign({}, this.contactBackup);
      this.civility = Object.assign({}, this.civilityBackup);
      this.editActivated = false;
    }
  }

  isRequired(): boolean {
    if (this.disabled) return false;
    if (!this.updateButton && !this.addButton) return false;
    if (!this.contact) return false
    if (this.updateButton) {
      return true;
    } else {
      return ((this.contact.Firstname || '') != '')
        || ((this.contact.Lastname || '') != '')
        || ((this.contact.Fonction || '') != '')
        || ((this.contact.Phone || '') != '')
        || ((this.contact.CellPhone || '') != '')
        || ((this.contact.Email || '') != '')
        || (!!this.required);
    }
  }
  
  get isInputControlDisabled():boolean{
    if (this.disabled) return true;
    if (this.addButton) return false;
    return  !this.editActivated;
  }

  get contactDejaExistant(): Contact {
    const emailCtrl : AbstractControl | undefined = this.supplierContactRowForm?.controls['Email'];
    if (emailCtrl && emailCtrl.hasError('emailUnique')) {
     return emailCtrl.errors['emailUnique'].contact;
    } else {
      return null;
    }
  }
  
  get btnAddDisabled(): boolean {
    if (!this.avecSaisie) return true;
    let avecError = false;
    if (!this.FrmSupplierContactRow) return true;
    Object.keys(this.FrmSupplierContactRow.controls).forEach((key: string) => {
      let control: AbstractControl = this.FrmSupplierContactRow.controls[key];
      control.markAsTouched();
      if (control.errors != null) {
        if (key != 'Email' || !control.errors['emailUnique']) {
          avecError = true;
          return;
        }
      }
    });
    return avecError;
  }

  get avecSaisie(): boolean {
    return (this.contact.Firstname || this.contact.Lastname || this.contact.Fonction || this.contact.Phone || this.contact.CellPhone || this.contact.Email || '') != '';
  }

  get TopCreateAccountDisabled(): boolean {
    if (!this.supplierContact) return true;
    return (this.supplierContact.CreateAccount || 0) == 2;
  }
  get TopCreateAccount(): boolean {
    if (!this.supplierContact) return false;
    return (this.supplierContact.IsReferent == 1 || (this.supplierContact.CreateAccount || 0) >= 1);
  }
  set TopCreateAccount(value: boolean) {
    if (!this.TopCreateAccountDisabled) {
      this.supplierContact.CreateAccount = (value ? 1 : 0);
    }
  }
  get TopCreateAccountLabel(): Observable<string> {
    if (this.noHeader) {
      return of('');
    } else {
      return this.Label('Acces_portail');
    }
  }
  setAsReferent():void{
    //On définie le contact en tant que référent du fournisseur
    //Il doit exister, avec un compte d'accès et ne pas être le référent actuel
    if (this.canSetAsReferent){
      this.setSupplierContactAsReferent.emit( this.supplierContact);
    }
  }

  get canSetAsReferent():boolean{
    //En mode creation, on peut modifier le référent
    if (this.disabled) return false;
    if ( this.supplierContact?.IsReferent==1) return false;
    if ((this.supplierContact?.CreateAccount ||0)!=2) return false;
    if (['010','100'].indexOf(this.supplierStatut?.Cod)>=0) {
      return this.suppliersSvc.canCreateSupplier;
    }
    if (this.sharedDataSvc.profil?.Cod=='FOURNISSEUR' && ['100'].indexOf(this.supplierStatut?.Cod)>=0) return true;
    return this.sharedDataSvc.checkProfilAccessPafSettings('FICHE_MAJ_CONTACT_REFERENT');
    //return ['ACH_OPERAT', 'ACH_FAMHA', 'CTRL_QUAL', 'ADMIN'].indexOf(this.sharedDataSvc.profil?.Cod) >= 0;
  }

}
